<template>
  <tr class="hover:bg-gray-100 focus-within:bg-gray-100">
    <template v-if="editableMode">
      <td class="border-t">
        <text-input v-model="detail.name" class="px-4 py-4" :error="errors.name" />
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 py-4">
          <select-input v-model="projectActivity.sector" class="w-full ">
            <option :value="null" default disabled>N/A</option>
            <option v-for="sector in sectors" :key="sector.id" :value="sector">{{ sector.name }}</option>
          </select-input>
        </div>
      </td>
      <td class="border-t">
        <textarea-input v-model="detail.description" class="px-4 py-4 whitespace-pre-line" :error="errors.description"
          rows="3" />
      </td>
      <td class="w-px border-t">
        <div class="flex justify-items-end px-6 py-4">
          <button title="Save Changes" @click="store">
            <Icon icon="ic:baseline-save" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Cancel Activity" @click="cancel">
            <Icon icon="ic:baseline-restart-alt" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </template>
    <template v-else>
      <td class="border-t">
        <div class="flex items-center px-6 focus:text-indigo-500 whitespace-pre-line">
          {{ projectActivity.name }}
        </div>
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 focus:text-indigo-500 whitespace-pre-line">
          {{ projectActivity.sector ? projectActivity.sector.name : 'N/A' }}
        </div>
      </td>
      <td class="border-t">
        <div class="flex items-center px-6 py-4 whitespace-pre-line">
          {{ projectActivity.description }}
        </div>
      </td>
      <td class="w-px border-t">
        <div class="flex items-center px-6 py-4">
          <button title="Edit Activity" @click="edit">
            <Icon icon="ic:baseline-edit-note" class="block w-6 h-6 fill-gray-400" />
          </button>
          <button title="Delete Activity" @click="destroy">
            <Icon icon="ic:baseline-delete" class="block w-6 h-6 fill-gray-400" />
          </button>
        </div>
      </td>
    </template>
  </tr>
</template>

<script>
import { Icon } from '@iconify/vue'
import { ref } from 'vue'
import clone from 'lodash/clone'
import TextInput from '@/Shared/TextInput'
import TextareaInput from '@/Shared/TextareaInput'
import SelectInput from '@/Shared/SelectInput'
export default {
  components: {
    Icon,
    TextInput,
    TextareaInput,
    SelectInput
  },
  props: {
    projectActivity: Object,
    sectors: Array,
    errors: Object,
    editableMode: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['destroy:detail', 'cancel', 'save', 'edit:detail'],
  setup(props) {
    const detail = ref(props.projectActivity)
    const oriData = ref(typeof projectActivities)

    return {
      detail,
      oriData,
    }
  },
  methods: {
    edit() {
      this.oriData = clone(this.projectActivity)
      this.$emit('edit:detail', this.detail)
    },
    cancel() {
      this.detail = clone(this.oriData)
      this.$emit('cancel')
    },
    store() {
      this.$emit('save', this.detail)
    },
    destroy() {
      if (confirm('Are you sure you want to delete this activities?')) {
        this.$emit('destroy:detail', this.projectActivity.id)
      }
    },
  },
}
</script>
